export const DATASTRUCTURE_REQUEST = "DATASTRUCTURE_REQUEST";
export const DATASTRUCTURE_SUCCESS = "DATASTRUCTURE_SUCCESS";
export const DATASTRUCTURE_FAILURE = "DATASTRUCTURE_FAILURE";
